import React from "react";
import Avatar from "../../../Avatar/Avatar";

const AbsentEmployeeList = ({ employeeList }) => {
  return (
    <div className="py-2 px-4">
      <div className="flex justify-between items-center border-b border-b-gray-300 py-3">
        <div className="flex justify-between items-center gap-3">
          <Avatar image={employeeList.photo} status="leave" />
          <div>
            <p className="text-sm leading-5 font-medium text-gray-800">
              {employeeList.employee_name}
            </p>
            <p className="text-xs leading-4 font-normal text-gray-500">
              {employeeList.location_name} | {employeeList.designation_title} | {employeeList.team_name}
            </p>
          </div>
        </div>
        <div className="flex gap-2 relative">
          {/* <i className="ico-right cursor-pointer"  /> */}

          <div className="flex gap-2 justify-center py-4"></div>
        </div>
      </div>
    </div>
  );
};

export default AbsentEmployeeList;
